import { createStore } from "vuex";
import data from "../assets/projects";

const projectTypes = ["programming", "design"];

const store = createStore({
  state: {
    projectTypes: projectTypes,
    mainMenuItems: [...projectTypes, "about me"],
    mainProjects: [1, 3, 4], // ID - 1 because array indexes!
    projects: data.projects,
    targetComponent: "home",
    detailProject: 1,
    overlayPicture: {
      index: 0,
      images: [],
      projectTitle: '',
    },
    easterEgg: false,
  },
  getters: {
    getMainProjects: (state) => {
      let mainP = [];
      for (let i = 0; i < state.mainProjects.length; i++) {
        const mainProjectId = state.mainProjects[i];
        state.projects.forEach(element => {
          if (element.id === mainProjectId) {
            mainP.push(element);
          }
        });
      }
      return mainP;
    },
    getProjectsType: (state) => (type) => {
      const projectsSorted = state.projects.sort((a, b) => a.id - b.id);
      return projectsSorted.filter((project) => project.projectType === type);
    },
    getHighlightProjectsType: (state) => (type) => {
      const projectsSorted = state.projects.sort((a, b) => a.id - b.id);
      return projectsSorted.filter((project) => project.projectType === type && project.highlight === true);
    },
    // getProject es per borrar
    getProject: (state) => (id) => {
      return state.projects.filter((project) => project.id === id)[0];
    },
    getSelectedProject: (state) => {
      return state.projects.filter((project) => {
        return project.id == state.detailProject;
      })[0];
    },
    getProjectTypes: (state) => {
      return state.projectTypes;
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});

export default store;
